import * as types from '../actionTypes/CartActionTypes';

const defaultState = {
    isMoveToCartSuccess: false,
    isMoveToSFLSuccess: false,
    isVerticalSflExpanded: false,
    errorMessage: '',
};

export default function SFLActionStatusReducer(state = defaultState, action) {
    // NOSONAR
    let newState = {};
    switch (action.type) {
        case types.SAVE_FOR_LATER_REQUEST_SUCCESS:
            // When item is moved from cart to sfl
            newState = { ...state };
            newState.isMoveToSFLSuccess = true;
            return newState;
        case types.RESET_MOVE_CART_SFL_SUCCESS:
            // Clear success message of move to sfl
            newState = { ...state };
            newState.isMoveToSFLSuccess = false;
            newState.errorMessage = '';
            return newState;
        case types.REMOVE_SAVED_ITEM_SUCCESS:
            // When item is moved from sfl to cart
            newState = { ...state };
            newState.isMoveToCartSuccess = true;
            return newState;
        case types.RESET_MOVE_SFL_CART_SUCCESS:
            // Clear success message of move to cart
            newState = { ...state };
            newState.isMoveToCartSuccess = false;
            newState.errorMessage = '';
            return newState;
        case types.SAVE_FOR_LATER_REQUEST_ERROR:
            // Clear success message of move to cart
            newState = { ...state };
            newState.isMoveToSFLSuccess = false;
            newState.errorMessage = action.errorMessage;
            return newState;
        case types.VERTICAL_SFL_VIEW_ALL:
            newState = { ...state };
            newState.isVerticalSflExpanded = action.payload || false;
            return newState;
        default:
            return state;
    }
}
